import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import {
    Dialog as DialogControl,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography
} from "components/controls/widget";
import CloseIcon from "common/icons/Close";
//import ContentBox from "common/components/ContentBox";
import { isString } from "components/utils";


export interface DialogProps {
    open: boolean;
    onClose: () => void;
    disableBackdropClick?: boolean;
    disableEscapeKeyDown?: boolean;
    fullScreen?: boolean;
    fullWidth?: boolean;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
    closeButton?: boolean;
    title?: React.ReactNode;
    actions?: React.ReactNode;
}


class Dialog extends React.PureComponent<DialogProps & WithStyles<typeof styles>> {
    render() {
        const { title, actions, classes, onClose, closeButton, ...other } = this.props;
        return <DialogControl {...other} onClose={onClose} >
            {title && <DialogTitle disableTypography className={classes.title}>
                <Grid container direction="row" alignItems="center">
                    <Grid item>
                        {isString(title) ? <Typography variant="h6" className={classes.titleTypo}>{title}</Typography> : title}
                    </Grid>
                    {onClose && closeButton ? (
                        <IconButton className={classes.closeButton} onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </Grid>
            </DialogTitle>}
            <DialogContent classes={{ root: classes.content }}>{this.props.children}</DialogContent>
            {actions && <DialogActions classes={{ root: classes.actions }}>{actions}</DialogActions>}
        </DialogControl>
    }
}


const styles = (theme: Theme) => createStyles({
    title: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit,
    },
    titleTypo: {
        paddingLeft: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
    },
    actions: {
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit,
    },
    content: {
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
    closeButton: {
        color: theme.palette.grey[500],
    },
});



export default withStyles(styles)(Dialog);